import axios from 'axios';

export const list = async (params = {}) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/sail-invoices`,
      headers: {
        Authorization: params.newToken,
      },
      params: {
        ...params,
        newToken: undefined,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const findOne = async ({ newToken, id } = {}) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/sail-invoices/pinv/${id}`,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const create = async ({ data, newToken } = {}) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/sail-invoices/send-einvoice`,
      data,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const createCondo = async ({ data, newToken } = {}) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/sail-invoices/send-einvoice/condo`,
      data,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const createPanoramica = async ({ data, newToken } = {}) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/sail-invoices-panoramica/send-einvoice`,
      data,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const saveCached = async ({ data, newToken, _id } = {}) => {
  try {
    const response = await axios({
      method: 'patch',
      url: `${process.env.REACT_APP_API_URL}/sail-invoices/${_id}`,
      data,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const changeStatus = async ({ data, newToken } = {}) => {
  try {
    const { id, ...body } = data;
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/sail-invoices/pinv/change-status/${id}`,
      body,
      {
        headers: { Authorization: newToken },
      }
    );

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};
